import { FETCH_GIFT_DATE_BUCKETS_SUCCEEDED } from './giftDateBucket.action';
import { pathOr } from 'ramda';

export const giftDateBucketReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_GIFT_DATE_BUCKETS_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/giftDateBuckets/giftDateBucket.reducer.js